import { Share } from '@cube3/common/model/schema/resources/share';
import { Button } from '@cube3/cubicle/src/core/atoms/Button';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';
import { HBox, VBox } from '@cube3/cubicle/src/core/templates/layout/Flex';
import { PropsWithChildren } from 'react';
import { useModalActions } from '../../Modals/modalActions';
import { ModalMenuUI } from '@cube3/ui/src/Modal/ModalMenuUI';
import { useDownloadFeedback } from '../../shares/hooks/useDownloadFeedback';
import { isMobile } from 'react-device-detect';
import { SizeVariants } from '@cube3/cubicle/src/theme/themes';

interface ModalReceivedProps {
  modalContext: {
    share: Share;
  };
}

export const ReviewToolSettingsModal = (props: ModalReceivedProps) => {
  const { share } = props.modalContext;

  const { previousModal } = useModalActions();

  const handleDownloadReport = useDownloadFeedback(share?.token);

  return (
    <ModalMenuUI
      autoHeight
      title={isMobile ? '' : 'Settings'}
      onCloseEvent={previousModal}
      footerRightComponent={
        <Button
          label="Close"
          buttonStyle="outline"
          onClick={previousModal}
          size={isMobile ? SizeVariants.lg : SizeVariants.md}
        />
      }
    >
      <VBox gap={16}>
        {!isMobile && <Typography colorVariant="01">Review logs</Typography>}
        <MainBody>
          <Typography variant={isMobile ? 'lg' : 'md'} colorVariant="03">
            Download a sheet containing all feedback
          </Typography>
          <Button
            buttonStyle="outline"
            background="secondary"
            iconLeft="download"
            onClick={handleDownloadReport}
            size={isMobile ? SizeVariants.lg : SizeVariants.md}
          >
            Download report
          </Button>
        </MainBody>
      </VBox>
    </ModalMenuUI>
  );
};

const MainBody = (props: PropsWithChildren) => {
  const { children } = props;

  return (
    <>
      {isMobile ? (
        <VBox gap={32} align="center" style={{ paddingTop: 24 }}>
          {children}
        </VBox>
      ) : (
        <HBox gap={8} align="center">
          {children}
        </HBox>
      )}
    </>
  );
};
